// Vendors
import { EmptyStatusComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { ERROR_COMPONENT_PROPS } from './constants/error.constants';
// Hooks
import { useErrorHook } from './hooks/error.hook';
// Styles
import { ErrorComponentStyled } from './error.component.styled';
// Types
import { ErrorComponentType } from './types/error.component.type';

const ErrorComponent = ({
  description,
  image = ERROR_COMPONENT_PROPS.image,
  onTryAgainClick,
  title,
}: ErrorComponentType): React.JSX.Element => {
  useErrorHook(onTryAgainClick);

  return (
    <ErrorComponentStyled>
      <EmptyStatusComponent
        {...{ ...ERROR_COMPONENT_PROPS, image }}
        description={<FormattedMessage id={description} />}
        title={<FormattedMessage id={title} />}
      />
    </ErrorComponentStyled>
  );
};

export { ErrorComponent };
